import { HeadingRow } from '@msaf/core-react'

export interface MapPanelContentProps {
  heading: string | JSX.Element
}

/*
Similar to @msaf/maps-react MapPanelContent but without the close button as in Wells
this is currently handled in WellsAdvancedSearchMap
*/

export function WellsMapPanelContent({ heading, children }: React.PropsWithChildren<MapPanelContentProps>) {
  return (
    <>
      <HeadingRow
        headingLevel={1}
        headingText={heading}
        headingClassNames='c-map-menu-panel__heading'
        verticalSpacing='none'
      />
      {children}
    </>
  )
}
